import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderDownloadAppModal = () => openPopupHelper({ popupName: popupNames.MOBILE_DOWNLOAD_APP });
